<ng-container *ngIf="!isPartial; else partialTemplate">
    <msc-common2-checkbox type="tick" [value]="value" (changeEvent)="onChange()"></msc-common2-checkbox>
</ng-container>

<ng-template #partialTemplate>
    <msc-common2-checkbox type="half" [value]="true" (changeEvent)="onChange()"></msc-common2-checkbox>
</ng-template>
